module.exports = __webpack_public_path__ + "assets/img/m-list-logo.8d894a1e.png";